import { useEffect } from "react";

export default function Seo({ title, desc }) {
  useEffect(() => {
    if (title) document.title = title;
    if (desc) {
      const m = document.querySelector('meta[name="description"]');
      if (m) m.setAttribute("content", desc);
    }
  }, [title, desc]);
  return null;
}
